module.exports = __webpack_public_path__ + "img/facts-all_1950.5cfd11bc.png";